import React from "react";
import { useNavigate } from "react-router-dom";
import Button from "../Button/Button";
import { FiArrowLeft } from "react-icons/fi";
import { ROUTES } from "../../constants/constants";
import styles from "./PageHeading.module.css";

interface PageHeadingProps {
  title: string;
  backTo?: string;
  className?: string;
}

const PageHeading: React.FC<PageHeadingProps> = ({
  title,
  backTo = ROUTES.HOME,
  className = "",
}) => {
  const navigate = useNavigate();
  return (
    <div className={`${styles.headingContainer} ${className}`}>
      <Button
        onClick={() => navigate(backTo)}
        className={styles.backButton}
        aria-label="Back"
      >
        <FiArrowLeft size={20} />
      </Button>
      <h1 className={styles.heading}>{title}</h1>
    </div>
  );
};

export default PageHeading;
